import { render, staticRenderFns } from "./BtColumnDistinctModel.vue?vue&type=template&id=fe55fa76&scoped=true&"
import script from "./BtColumnDistinctModel.vue?vue&type=script&lang=js&"
export * from "./BtColumnDistinctModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe55fa76",
  null
  
)

export default component.exports